module.exports = new __parcel__URL__("team-two-people.dd270d21.svg").toString();